<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" class="mx-auto" dark>
                            <v-card-title class="headline">
                                Generar Autenticación de 2 pasos para:
                                {{ this.$store.state.mail.toString().trim() }}
                            </v-card-title>

                            <v-card-text class="headline layout justify-center">
                                <div>
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                            <img width="200" :src="'data:image/png;base64,' + qrCode" v-if="qrCode" />
                                        </v-col>
                                    </v-row>
                                    <!-- <img width="100" :src="'data:image/svg+xml;base64,' + qrCode" v-if="qrCode" /> -->
                                    <!-- <p>Clave Secreta: {{ secretKey }}</p> -->
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                            <v-text-field v-model="otpCode" label="Código OTP"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-card-title class="headline layout justify-center pa-0">
                                        <v-btn @click="validateOtp">Verificar</v-btn>
                                        <p v-if="message">{{ message }}</p>
                                    </v-card-title>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>
<script>
import axios from "../axios-auth";
export default {
    data() {
        return {
            qrCode: "",
            secretKey: "",
            otpCode: "",
            message: "",
        };
    },
    async created() {
        const response = await axios.post("/Authenticator/generate?", {
            accountName: this.$store.state.mail.toString().trim(),
        });
        this.qrCode = response.data.qrCode;
        this.secretKey = response.data.secretKey;
    },
    methods: {
        async validateOtp() {
            const response = await axios.post("/Authenticator/validate", {
                secretKey: this.secretKey,
                code: this.otpCode,
                mail: this.$store.state.mail.toString().trim(),
            });

            this.message = response.data.success ? "Código válido ✅" : "Código incorrecto ❌";
            console.log("mensaje ", response.data, response.data.success)
        },
    },
};
</script>